import React from "react"
import Contact from "./components/contact"

function Footer(){
    return(
        <Contact />
    )
}

export default Footer;